import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    firstName: checkRequiredText(settings),
    lastName: checkRequiredText(settings),
});

export const NameSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formFirstName">
                    <Form.Label>Vorname*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Vorname eingeben"
                        type="text"
                        name="firstName"
                        value={values.firstName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.firstName && !errors.firstName}
                        isInvalid={touched.firstName && errors.firstName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.firstName}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formLastName">
                    <Form.Label>Nachname*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Nachname eingeben"
                        type="text"
                        name="lastName"
                        value={values.lastName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.lastName && !errors.lastName}
                        isInvalid={touched.lastName && errors.lastName}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.lastName}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};